// Jul-2026 (User-Wunsch) — Lead-Benachrichtigung: pollt unsichtbare Alerts
// (GET /dealer/leads/alerts) und zeigt dem zugeteilten Verkäufer sofort einen
// Toast mit Link zur Lead-Liste. Markiert Alerts danach als gesehen.
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { toast } from "sonner";

export const LeadAlertsWatcher = ({ role }) => {
    const navigate = useNavigate();
    const timer = useRef(null);

    useEffect(() => {
        if (!["b2b", "zweiradverkaeufer"].includes(role)) return undefined;
        let stopped = false;
        const poll = async () => {
            try {
                const { data } = await api.get("/dealer/leads/alerts");
                const items = data?.items || [];
                if (items.length && !stopped) {
                    items.slice(0, 3).forEach((a) => {
                        toast.info(a.title || "Neuer Lead für dich", {
                            description: [a.lead_label?.trim(), a.customer].filter(Boolean).join(" · ") || undefined,
                            duration: 12000,
                            action: { label: "Öffnen", onClick: () => navigate("/dealer/leads") },
                        });
                    });
                    await api.post("/dealer/leads/alerts/seen", { ids: items.map((a) => a.id) });
                }
            } catch { /* still logged out / offline → einfach weiter pollen */ }
        };
        poll();
        timer.current = setInterval(poll, 45000);
        return () => { stopped = true; clearInterval(timer.current); };
    }, [role, navigate]);

    return null;
};
